import React from 'react';
import PropTypes from 'prop-types';
import { FieldList, ClientDetails } from '../../';
import { Link } from 'react-router';
import { Panel, Row, Col, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as Actions from 'actions';

class JobPreview extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { client, job } = this.props;

    if(!job) {
      return <div><h3 className="text-center">Please Select an Opportunity</h3></div>
    }

    const is_job = job.status == 'Job';
    const bsStyle = is_job ? 'primary' : 'secondary';

    const footer = <div className="clearfix">
      <Link to={`client/${job.client._id}/job/${job._id}`} className="pull-right btn btn-default">View {job.status}</Link>
    </div>;
    return <div className="job-preview">
      <Panel
        bsStyle={bsStyle}
        header={<h3 className="title"><i className={`fa fa-${!is_job ? 'address-card-o' : 'handshake'}`}></i> {`${job.client.name}`}</h3>}
        footer={footer}
      >
        <Row>
          <Col xs={12} md={6} lg={7} xl={9}>
            {/*JSON.stringify(this.props.job)*/}
            <Row className="mb-none">
              <Col xs={12} md={12}>
                <h4 className="text-muted ">
                  <span className="label label-md label-primary">{job.status}-{job.number}</span>{' '}
                  <span className="label label-md label-default"><i className="fa fa-user"></i> {job.assigned_to ? job.assigned_to.name.first + ' ' +job.assigned_to.name.last : 'Not assigned.'}</span>{' '}
                  <span className="label label-md label-default"><span className="text-success"><i className="fa fa-money"></i> {is_job ? `$${Number(job.price).toLocaleString()}` : `$${Number(job.estimate).toLocaleString()}`}</span></span>{' '}
                </h4>
              </Col>
            </Row>
            <hr className="dotted mt-none" />
            <h3 className="text-muted">{job.status} Details</h3>
            <FieldList
              fields={[
                {_id : 3, name : 'work_type', label : 'Work Type', flex : 4},
                {_id : 4, name : 'category', label : 'Category', flex : 4},
                {_id : 1, name : 'trade', type : 'multiselect', label : 'Trade', flex : 4},
                {_id : 2, name : 'claim_number', label : 'Claim Number', flex : 12},
              ]}
              entity={job}
              readOnly={true}
            />
            <hr className="dotted" />
            <h3 className="text-muted">Description</h3>
            <p>{job.description || 'None provided.'}</p>
          </Col>
          <Col xs={12} md={6} lg={5} xl={3}>
            <h3 className="text-muted">Client</h3>
            <p>The client attatched to this lead.</p>
            {job.client && job.client._id ? <ClientDetails simple={true} client={job.client} /> : ''}
          </Col>
        </Row>
      </Panel>
    </div>
  }
}

JobPreview.propTypes = {
  job : PropTypes.object,
  client : PropTypes.object,
}

const mapStateToProps = ({ jobs }) => ({
  ...(jobs.downloaded_jobs.find(({job}) => job._id == jobs.previewing_job) || {}),
});

export default connect(mapStateToProps,Actions)(JobPreview);



// WEBPACK FOOTER //
// ./src/browser/components/client/jobs/job-preview.js